<template>
  <div class="discount-price-wrapper">
    <div class="discount-num" v-show="discountPrice(sku.activity,sku.equity,sku.market_price)">
      <!-- <img alt src="../assets/img/home-change/v.png" /> -->
      <span class="num">省 ¥{{ discountPrice(sku.activity,sku.equity,sku.market_price)}}</span>
    </div>
  </div>
</template>

<script>
import Big from 'big.js'
const init = new Big(0)
export default {
  props: {
    sku: {
      type: Object
    }
  },
  computed: {
    discountPrice (ap, mp, np) {
      return (ap, mp, np) => {
        if (ap && ap.discount) {
          const dif = init.plus(np).minus(ap.discount).toFixed(2)
          return dif > 0 ? dif : 0
        } else if (mp && mp.discount) {
          const dif = init.plus(np).minus(mp.discount).toFixed(2)
          return dif > 0 ? dif : 0
        } else {
          return false
        }
      }
    }
  }

}
</script>

<style lang="less" scoped>
.discount-price-wrapper {
  display: flex;
}
.discount-num {
  position: relative;
  display: flex;
  align-items: center;
  white-space: nowrap;
  margin-left: 0.1rem;
  color: #fff;
  padding-left: 0.05rem;
  padding-right: 0.15rem;
  height: 0.26rem;
  font-size: 0.2rem;
  background: linear-gradient(
    90deg,
    rgba(255, 103, 51, 1) 0%,
    rgba(255, 69, 20, 1) 100%
  );
  border-radius: 0 30px 30px 20px;
  z-index: 3;
  &::after {
    position: absolute;
    content: "";
    left: -2px;
    top: -1px;
    border-top: 4px solid transparent;
    border-right: 2px solid rgba(255, 103, 51, 1);
    border-bottom: 0px solid transparent;
    border-left: 0px solid transparent;
    transform: rotate(-90deg);
  }
  .num {
    overflow: hidden;
    max-width: 1.3rem;
  }
  img {
    width: 0.3rem;
    height: 0.18rem;
    object-fit: contain;
    z-index: 4;
  }
}
</style>
